/**
 * UserManagementService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class ManageUsersService {
    signUpUser = (body) => {
        return apiClient.post("/user/register", body);
    }

    getAllUsers = () => {
        return apiClient.get("/users");
    }

    UpdateUser = (id, body) => {
        return apiClient.put("/users/" + id + "/update", body);
    }

    getAllContacts = () => {
        return apiClient.get("/contactpage/get");
    }

    createContact = (body) => {
        return apiClient.post("/contactpage", body);
    }

    UpdateContactStatus = (body) => {
        return apiClient.put("/contactpage/update", body);
    }

    updateUserPassword = (body) => {
        return apiClient.put("/user/password/update", body);
    }
}
